export default __webpack_public_path__ + "static/media/nu.390d7c50.svg";